module.exports = __webpack_public_path__ + "static/img/2018-06-09 16.19.01.e162667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2018-06-09 16.19.01.jpg
// module id = kuhR
// module chunks = 4